import { c as _c } from "react/compiler-runtime";
import { cn } from '@newfront-insurance/core-ui/v2';
import type { ReactNode } from 'react';
interface ChatHeaderProps {
  children: ReactNode;
  className?: string;
}

/**
 * Header wrapper component for chat interface.
 * Accepts children for flexible composition of header actions.
 *
 * @example
 * ```tsx
 * <ChatHeader>
 *   <NewChatButton />
 *   <ToggleSidebar />
 *   <AccountSelector />
 *   <ChatHeaderActions />
 * </ChatHeader>
 * ```
 */
export function ChatHeader(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("border-border/50 bg-background flex h-14 shrink-0 items-center justify-between rounded-t-sm border-b px-6", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <header className={t1}>{children}</header>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}